<script lang="ts">
  // BJL-CHECK: Timeline, Button — the leg list interleaves dotted walk connectors with
  // route-colored ride spines, which bjl Timeline has no marker slot for. See
  // artifacts/deviations/PlanPage.md.
  import { Button } from '@byjackli-labs/ui/Button'
  import { Colors } from '../../ui/colors'
  import { Type } from '../../ui/theme'
  import type { Itinerary } from '../../services/api'
  import { useTripPlanStore } from '../../store/tripPlan'
  import { useRiderStore } from '../../store/rider'
  import { fmtDuration, fmtTime, walkMinutes } from './format'
  import RideStep from './RideStep.svelte'

  interface Props {
    it: Itinerary
    onBack: () => void
    onStart?: () => void
  }

  const { it, onBack, onStart }: Props = $props()

  const hasRide = $derived(it.legs.some((l) => l.mode !== 'walk'))

  // Start the trip: draw it on the map, arm its first ride leg in the rider store, and
  // get out of the way — from here the rider is looking at the map, not this sheet.
  function start() {
    useTripPlanStore.getState().setActiveItinerary(it)
    useRiderStore.getState().startPlannedTrip(it)
    onStart?.()
  }
</script>

<div style="display: flex; flex-direction: column; gap: 12px;">
  <div style="display: flex; align-items: center; gap: 10px;">
    <Button variant="secondary" size="sm" onclick={onBack}>‹ Back</Button>
    <span style="color: {Colors.text}; {Type.title};">
      {fmtTime(it.departureTime)} → {fmtTime(it.arrivalTime)}
    </span>
    <span style="color: {Colors.textSecondary}; {Type.body}; margin-left: auto;">
      {fmtDuration(it.durationSec)}
    </span>
  </div>

  <div>
    {#each it.legs as leg, i (i)}
      {#if leg.mode === 'walk'}
        <div style="display: flex; gap: 10px;">
          <div style="width: 26px; display: flex; flex-direction: column; align-items: center;">
            <span style="font-size: 15px;">🚶</span>
            <div
              style="width: 0; flex: 1; min-height: 14px; border-left: 3px dotted {Colors.textMuted};"
            ></div>
          </div>
          <div style="flex: 1; padding-bottom: 12px; color: {Colors.textSecondary}; {Type.body};">
            Walk {walkMinutes(leg)} min to
            <b style="color: {Colors.text};">{leg.to.name}</b>
            {#if leg.distanceMeters > 0}
              <span style="color: {Colors.textMuted};"> · {leg.distanceMeters} m</span>
            {/if}
          </div>
        </div>
      {:else}
        <RideStep {leg} />
      {/if}
    {/each}
  </div>

  {#if hasRide}
    <Button onclick={start} style="width: 100%; padding-top: 14px; padding-bottom: 14px; font-size: var(--bjl-font-size-md); font-weight: var(--bjl-font-weight-bold, 700);">
      ▶ Start trip
    </Button>
  {/if}

  <Button
    variant="secondary"
    size="sm"
    onclick={() => useTripPlanStore.getState().setActiveItinerary(null)}
    style="align-self: flex-start;"
  >Clear route from map</Button>
</div>
